import Vue from 'vue';
import Vuex, {ActionContext, Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction,
} from '@/shared/utils';
import {Devis} from '@/models';
import {DevisService} from "@/xhttp/DevisService";

import {DateFilter} from '@/shared/filter';
import store from '@/stores';

Vue.use(Vuex);

export class DevisFilter {

	name: string = '';
	email: string = '';
	remarques: string = '';
	address: string = '';
	zipCode: string = '';
	town: string = '';
	country: string = '';

	public clear(): void {
		this.name = '';
		this.email = '';
		this.remarques = '';
		this.address = '';
		this.zipCode = '';
		this.town = '';
		this.country = '';
	}

	public toString(): string {
		return JSON.stringify(this);
	}
}

class DevisState extends PaginatorFilterState<DevisFilter> {
	devis: Devis = null;
	devisGetC: ResultType<Devis> = null;
	public constructor() {
		super(new DevisFilter(), 'devis', 'devis', 'id', AscDesc.DESC, 20)
	}
}

class DevisStore {

	@XHTTPService(() => Devis)
	private devisService: DevisService;
	private  _store: Store<any>;

	public state: DevisState = new DevisState();

	public mutations = {
		...PaginatorMutation(() => this._store, 'devis', 'devis'),
	};

	public actions = {
		...StandardAction<Devis, DevisState>(() => Devis, 'devis'),
		...PaginatorActionWithFilters<Devis, DevisState>(() => Devis, 'devis', 'devis'),

		putChangeState(context: ActionContext<DevisState, any>, { devis, refused }) {
			return instance.devisService.putChangeState(devis, refused);
		},
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}

}

const instance = new DevisStore();
const storeDevis = new Vuex.Store(instance);
instance.init(storeDevis);

const instancePrix = new DevisStore();
export const storeDevisPrix = new Vuex.Store(instancePrix);
instancePrix.init(storeDevisPrix);

store.registerModule('devis', storeDevis);
store.registerModule('devisPrix', storeDevisPrix);
export default storeDevis;